export default function ThreatDirective() {
  return {
    template: require('./threat.html'),
    require: '^^form',
    scope: {
      threat: '=',
      threatImpactOptions: '=',
      threatProbabilityOptions: '=',
    },
    controller: 'ThreatController',
    controllerAs: 'threatVM',
    bindToController: true,
    replace: true,
    link: (scope) => {
      const vm = scope.threatVM;
      scope.selectedThreatImpactOption = {
        threatImpactOption: vm.threat.threatImpactOption,
        threatImpactOptionId: vm.threat.threatImpactOptionId,
      };
      scope.selectedThreatProbabilityOption = {
        threatProbabilityOption: vm.threat.threatProbabilityOption,
        threatProbabilityOptionId: vm.threat.threatProbabilityOptionId,
      };
      scope.changeOption = () => {
        const threat = scope.threatVM.threat;
        const impactOption = scope.selectedThreatImpactOption;
        const probabilityOption = scope.selectedThreatProbabilityOption;
        threat.threatImpactOption = getVal(impactOption, 'name', '');
        threat.threatImpactOptionId = getVal(impactOption, 'threatImpactOptionId', -1);
        threat.threatProbabilityOption = getVal(probabilityOption, 'name', '');
        threat.threatProbabilityOptionId = getVal(probabilityOption, 'threatProbabilityOptionId', -1);
      };
      scope.getDisplayValue = (option) => {
        if (!option) {
          return 'Loading...';
        }
        if (option.sortOrder === 0) {
          return '---Please select---';
        }
        return option.displayValue;
      };
    }
  };

  function getVal(obj, key, defaultVal) {
    return obj ? obj[key] : defaultVal;
  }
}
